import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E勘定科目カテゴリ } from '@/openapi/enum';

import 勘定科目Mixin from '@/entries/user/mixins/勘定科目Mixin';

export default mixins(勘定科目Mixin).extend({
  name: 'M勘定科目カテゴリComponentMixin',

  props: {
    e勘定科目カテゴリ: {
      type: Number as PropType<E勘定科目カテゴリ>,
      required: true,
    },
  },

  computed: {
    is貸借(): boolean {
      return this.is貸借カテゴリ(this.e勘定科目カテゴリ);
    },
  },
});
